import { Box, Stack } from '@mui/material';
import { DetailsBox } from './DetailsBox';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import LandscapeIcon from '@mui/icons-material/Landscape';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import { FC } from 'react';

type LeftDetailsProps = {
  calories: number;
  moves: number;
  elevation: number;
};

export const LeftDetails: FC<LeftDetailsProps> = ({
  calories,
  moves,
  elevation,
}) => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: '#202123',
        height: '100%',
        padding: 2,
      })}
    >
      <Stack
        direction="column"
        spacing={2}
        className="w-full"
        justifyContent="center"
        alignContent="center"
        sx={(theme) => ({ height: '100%' })}
      >
        <DetailsBox
          number={calories.toFixed(1)}
          title={'calories'}
          subtitle={'kcal'}
          color="#e75d7a"
          icon={
            <LocalFireDepartmentIcon
              fontSize="inherit"
              sx={{
                position: 'absolute',
                top: '23px',
                fontSize: 42,
                color: '#e75d7a',
              }}
            />
          }
        />
        <DetailsBox
          number={moves.toFixed(0)}
          title={'moves'}
          subtitle={'MOVEs'}
          color="#fdff16"
          icon={
            <Brightness7Icon
              fontSize="inherit"
              sx={{
                position: 'absolute',
                top: '23px',
                fontSize: 42,
                color: '#fdff16',
              }}
            />
          }
        />
        <DetailsBox
          number={elevation.toFixed(0)}
          title={'elevation'}
          subtitle={'meters'}
          color="#06e3ef"
          icon={
            <LandscapeIcon
              fontSize="inherit"
              sx={{
                position: 'absolute',
                top: '23px',
                fontSize: 42,
                color: '#06e3ef',
              }}
            />
          }
        />
      </Stack>
    </Box>
  );
};
